import {Injectable} from "@angular/core";
import {ApiUrls} from "@app/core/shared/infrastructure/api-urls";
import {BaseHandleErrorMapper} from "@app/core/shared/infrastructure/base.handler/base-handle-error.mapper";
import {HandlerBuilder, HttpMethod} from "@app/core/shared/infrastructure/base.handler/base-handle.parameters";
import {EuropastryBaseHandler} from "@app/core/shared/infrastructure/base.handler/europastry-base.handler";
import {Observable} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {Country} from "../domain/dtos/country";
import {Province} from "../domain/dtos/province";
import {Workplace} from "../domain/dtos/workplace";
import {MasterDataRemote} from "../domain/repositories/master-data.remote";
import {MasterDataObjectMapper} from "./mappers/master-data-object.mapper";

@Injectable({
    providedIn: "root",
})

export class MasterDataWebService implements MasterDataRemote {

    constructor(
        private baseHandler: EuropastryBaseHandler,
        private apiUrls: ApiUrls,
    ) { }

    getWorkplaces(): Observable<Workplace[]> {
        const parameters = new HandlerBuilder()
            .method(HttpMethod.get)
            .url(this.apiUrls.WORKPLACES)
            .build()

        return this.baseHandler.execute(parameters).pipe(
            map(response => response.results.map(MasterDataObjectMapper.deserialize)),
            catchError(BaseHandleErrorMapper.handleError)
        )
    }

    getCountries(): Observable<Country[]> {
        const parameters = new HandlerBuilder()
            .method(HttpMethod.get)
            .url(this.apiUrls.COUNTRIES)
            .build()

        return this.baseHandler.execute(parameters).pipe(
            map(response => response.results.map(MasterDataObjectMapper.deserialize)),
            catchError(BaseHandleErrorMapper.handleError)
        )
    }

    getProvinces(countryCode: string): Observable<Province[]> {
        const parameters = new HandlerBuilder()
            .method(HttpMethod.get)
            .url(this.apiUrls.PROVINCES + countryCode)
            .build()

        return this.baseHandler.execute(parameters).pipe(
            map(response => response.results.map(MasterDataObjectMapper.deserialize)),
            catchError(BaseHandleErrorMapper.handleError)
        )
    }

}
